export const CONTENT_TILES_DEFAULT_COUNT = 14;
